module.exports = __webpack_public_path__ + "static/mural-3-a7bc7b0de6ff21b33c696d9afb619cd0.jpg";